module.exports = {
    // basic
    'request-access': 'request access',
    'sign-in': 'sign in',
    'support': 'support',
    'alternate': 'alternate',
    'copyright': 'copyright',
    'forgot-your-password': 'forgot your password?',
    'version': 'version',
    'locked-out': 'locked out?',
    'other-issues': 'other issues?',
    'terms-and-conditions-header': 'website terms of use',
    'schedule-a-demo': 'schedule a demo',
    'learn-more': 'click here to learn more',
    'trouble-signing-in': 'trouble signing in?',
    'i-accept': 'i accept',
    'i-dont-accept': 'i do not accept',
    'continue': 'continue',
    'unsupported-browser': 'unsupported browser',

    // raw
    'request-access-success': `
        <p>
            Your request for access has been received.
        </p>
        <p>
            WellDrive Operations will review your request and contact you once it has been approved.
        </p>
        <p>
            <a href="login.html" class="btn btn-primary">Return to Sign In page</a>
        </p>
    `,
    'forgot-password-request-success': `
        <p>
            If the user name you specified exists in our system, we've sent a password reset link to your email.
        </p>
        <a href="#login" class="forgot-password-link">Back to Sign In page</a>
    `,
    'forgot-password-request-fail': `
        <p>
            We are unable to complete your request.
        </p>
        <p>
            Please follow the instructions below for <b>Locked Out</b> users.
        </p>
    `,
    'bad-credentials': 'The user name or password is incorrect.',
    'account-locked': 'Your account is locked. Give us a call 24/7 at (877) 704-8270 or email us at ops@welldrive.com.',
    'account-lock-warning': 'The next failed sign in attempt will result in your account being locked.',
    'account-has-no-role': 'Your account requires further configuration.  Please contact WellDrive Operations for assistance.',
    'account-locked-inactive': 'Your account is locked due to inactivity. To unlock your account, please give us a call 24/7 at (877) 704-8270 or email us at ops@welldrive.com.',
    'login-header': 'All your well data in one place.',
    'login-title': 'Sign in to WellDrive',
    'forgot-password-description': 'Enter your user name and we will send an email with further instructions to the email address on file for that account.',
    'login-body': 'WellDrive connects Operators, Service Companies and Partners in a way no other solution ever has, to put all your well files at your fingertips, for easy search and sharing.',
    'login-tagline': 'Save time, money, effort - and the headache of finding and cleaning up data.',
    'apps-available': 'Available on iOS and Android.',
    'uploads': 'Uploads',
    'uptime': 'Uptime',
    'owners-and-operators': 'Owners & Operators',
    'service-companies': 'Service Companies',
    'active-users': 'Active Users',
    'operations-support': 'Operations Support',
    'sales-and-marketing': 'Sales and Marketing',
    'locked-out-body1': `If you haven't signed in for some time, you may find your account has been locked due to inactivity.`,
    'locked-out-body2': `Give us a call 24/7 at <a href="tel:8777048270" class="forgot-password-link">(877) 704-8270</a> or email us at`,
    'other-issues-body': `Try reloading the webpage, using a different browser, or clearing your browser cache. If you're still having trouble, call us 24/7 at <a href="tel:8777048270" class="forgot-password-link">(877) 704-8270</a> or email us at`,
    'looking-for-more-info': 'Looking for more information about WellDrive?',
    'looking-for-more-info-body': `Click here for details about WellDrive's suite of offerings, latest news and more.`,
    'coming-soon': 'Coming Soon!',
    'new-user': 'New WellDrive User?',
    'new-user-body': `To request access, submit the form below, call us 24/7 at <a href="tel:8777048270" class="forgot-password-link">(877) 704-8270</a> or email us at`,
    'terms-and-conditions': 'Terms and Conditions',
    'browser-not-supported-1': `
        <p>
            The browser you are using is not officially supported by WellDrive.
        </p>
        <p>
            To take full advantage of WellDrive, please use the latest version of one of the following officially supported browsers:
        </p>
    `,
    'browser-not-supported-2': `
        <p>
            You can click the button below to continue to the site using your current browser, but some functionality may not work as intended and you may experience poor performance.
        </p>
        <p>
            If you think that you received this message in error or have any questions, we are always here to help. Email us at <a href="mailto:ops@welldrive.com">ops@welldrive.com</a> or call us at <a
            href="tel:18777048270">1-877-704-8270</a>.
        </p>
    `,
    'chrome-download-tooltip': 'Click to download.',
    'firefox-download-tooltip': 'Click to download.',
    'edge-download-tooltip': 'Microsoft Edge is already installed on Windows 10. It can also be installed on Windows 7, 8 and 8.1.',
    'safari-download-tooltip': 'Safari is the default browser on Apple Mac OSX and iOS. It is only available on Apple operating systems.',
    'sso-required': `
        This account is required to sign in using Single Sign On (SSO).<br />
        Please visit <a href="https://enterprise.welldrive.com" target="_blank">https://enterprise.welldrive.com</a> and sign in using your company credentials.
    `,

    // template
};
